import { render, staticRenderFns } from "./CMS-list.vue?vue&type=template&id=25702926&"
import script from "./CMS-list.vue?vue&type=script&lang=js&"
export * from "./CMS-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports